import m from './module';

const path = '/recap/event_type';

class EventTypeService {
  constructor(APIService, LogService) {
    "ngInject";
    this.APIService = APIService;
    this.LogService = LogService;
  }

  /**
   * @returns {Promise<Array>} Array of event type objects with {id, name}
   */
  getAll() {
    return this.APIService.get(path)
      .then(response => {
        return response.data || [];
      })
      .catch(error => {
        this.LogService.error('Failed to load event types', error);
        return [];
      });
  }
}

export default EventTypeService;

m.service('EventTypeService', EventTypeService);

export { EventTypeService };
